exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar-title[data-v-752cf1db]{font-family:SFProBold;font-size:20px}.text-center[data-v-752cf1db]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-752cf1db","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/b2b/profile/QrCodeDialog.vue
// module id = xH3s
// module chunks = 0